// removed by extract-text-webpack-plugin
module.exports = {"root":"components-Header-__index__root__q3z7j","title":"components-Header-__index__title__1trki","subtitle":"components-Header-__index__subtitle__1Alon","source":"components-Header-__index__source__1TPiF"};


//////////////////
// WEBPACK FOOTER
// ./components/Header/index.css
// module id = 678
// module chunks = 0